export default __webpack_public_path__ + "static/media/center-selection.2e6f81d2.svg";